import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useEffect, useState } from "react";
import EditChargesModal from "./EditChargesModal";
import { ChargesListContainer } from "./styles";
import dayjs from "dayjs";
import {
  getDayjsObject,
  getRefListItemsbyName,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { Popconfirm } from "antd";
import { TableActionsHeader } from "@/common/styles";
import _ from "lodash";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const header = [
  { key: "sequence", text: "ID" },
  { key: "chargeDescription", text: "Charge" },
  { key: "courtNumber", text: "Court File Number" },
  { key: "chargeCount", text: "CNT" },
  { key: "scheduledReleaseDate", text: "Release Date" },
  { key: "controllingAgencyORI", text: "Controlling Agency" },
  { key: "controllingCharge1", text: "Controlling Charge " },
  { key: "sentence", text: "Sentence" },
  { key: "sentenceConsecutive", text: "Consecutive" },
  { key: "clearedToGo", text: "Cleared" },
  { key: "requiresBond", text: "Bail" },
  { key: "bookingBailID", text: "Bail ID" },
  { key: "sentenced", text: "Sentenced" },
  { key: "sealed", text: "Sealed" },
];

const ChargesList = ({ chargesData, switchToAddCharges, bookingBails,startingPoint }) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [isModalShown, setIsModalShown] = useState(false);
  const [tempChargesData, setTempChargesData] = useState([]);
  const [selectChargeData, setSelectChargeData] = useState(null);
  const [editShow, setEditShow] = useState(false);

  useEffect(() => {
    console.log(chargesData);

    setTempChargesData(() => chargesData);
  }, [chargesData]);

  const onModalHide = () => {
    setIsModalShown(false);
    cancelAction();
    setEditShow(false);
  };

  const onModalShow = () => {
    setIsModalShown(true);
  };

  const selectChargeFn = (data) => {
    const values = chargesData?.find((c) => c?.uuid == data?.uuid);
    setSelectChargeData(() => ({
      ...values,
      offenseDateTime:
        isNonEmptyVariable(values?.offenseDate) &&
        isNonEmptyVariable(values?.offenseTime)
          ? dayjs(values?.offenseDate + " " + values?.offenseTime)
          : null,
      dispositionDate: isNonEmptyVariable(values?.dispositionDate)
        ? dayjs(values?.dispositionDate)
        : null,
      clearanceDateTime:
        isNonEmptyVariable(values?.clearanceDate) &&
        isNonEmptyVariable(values?.clearanceTime)
          ? dayjs(values?.clearanceDate + " " + values?.clearanceTime)
          : null,
      sentenceDate: isNonEmptyVariable(values?.sentenceDate)
        ? dayjs(values?.sentenceDate)
        : null,

      sentenceStartDateTime:
        isNonEmptyVariable(values?.sentenceStartDate) &&
        isNonEmptyVariable(values?.sentenceStartTime)
          ? dayjs(values?.sentenceStartDate + " " + values?.sentenceStartTime)
          : null,

      sentenceEndDate: isNonEmptyVariable(values?.sentenceEndDate)
        ? dayjs(values?.sentenceEndDate)
        : null,

      scheduledReleaseDateTime:
        isNonEmptyVariable(values?.scheduledReleaseDate) &&
        isNonEmptyVariable(values?.scheduledReleaseTime)
          ? dayjs(
              values?.scheduledReleaseDate + " " + values?.scheduledReleaseTime
            )
          : null,
      deadlineDateTime1Local: isNonEmptyVariable(values?.deadlineDateTime1)
        ? dayjs(values?.deadlineDateTime1)
        : null,
      deadlineDateTime2Local: isNonEmptyVariable(values?.deadlineDateTime2)
        ? dayjs(values?.deadlineDateTime2)
        : null,

      deadlineStartDateTime:
        isNonEmptyVariable(values?.deadlineStartDate) &&
        isNonEmptyVariable(values?.deadlineStartDate)
          ? dayjs(values?.deadlineStartDate + " " + values?.deadlineStartTime)
          : null,

      deadlineSatisfiedDateTime1: getDayjsObject(
        values?.deadlineSatisfiedDate1,
        values?.deadlineSatisfiedTime1
      ),
      deadlineSatisfiedDateTime2: getDayjsObject(
        values?.deadlineSatisfiedDate2,
        values?.deadlineSatisfiedTime2
      ),
    }));
    setEditShow(true);
  };

  const addCharge = () => {
    setSelectChargeData(null);
    onModalShow();
  };

  const editCharge = () => {
    onModalShow();
  };

  const deleteCharge = () => {
    let data = _.cloneDeep(chargesData);
    data = data?.filter((d) => {
      return d?.uuid !== selectChargeData?.uuid;
    });

    dispatch(
      setBookings({
        charges: data,
      })
    );
    const url = API_ENDPOINTS.charges + "/id/" + selectChargeData?.chargeID;
    dispatch(setDeleteAPis(url));
    cancelAction();
  };

  const cancelAction = () => {
    setSelectChargeData(() => null);
    setEditShow(false);
  };

  return (
    <>
      <ChargesListContainer>
        <TableActionsHeader className="action-header-row">
          <div className="left">
            {
              <Button
                color="primary"
                type="primary"
                onClick={addCharge}
                disabled={
                  !bookingsFieldsEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.ADD,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Add Charges
              </Button>
            }
          </div>
          <div className="right">
            {
              <Button
                color="primary"
                type="primary"
                onClick={editCharge}
                disabled={
                  !editShow ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Details
              </Button>
            }
            {
              <Popconfirm
                title="Delete the charges"
                description="Are you sure to delete this charges?"
                onConfirm={deleteCharge}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  color="primary"
                  type="primary"
                  disabled={
                    !editShow ||
                    !bookingsFieldsEnabled ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.subModule,
                      LABELS_CAPITAL.DELETE,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      SUB_MODULES_LIST_WITH_ID.Arrest_Report
                    )
                  }
                >
                  DELETE
                </Button>
              </Popconfirm>
            }

            <Button
              color="primary"
              type="primary"
              onClick={cancelAction}
              disabled={!editShow}
            >
              Cancel
            </Button>
            {/* <Button
              color="primary"
              type="primary"
              disabled={!bookingsFieldsEnabled}
            >
              Live Scan
            </Button> */}
          </div>
        </TableActionsHeader>
        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={header}
            data={tempChargesData?.map((td, index) => {
              return {
                ...td,
                chargeDescription: getRefListNameByID(
                  "Charges",
                  td?.chargeDescriptionID
                ),
                controllingAgencyORI: getRefListNameByID(
                  "Controlling_Agency",
                  td?.controllingAgencyORIID,
                  false,
                  true
                ),
                sequence: td?.sequence || index + 1,

                requiresBond: td?.requiresBond ? "True" : "False",
                clearedToGo: td?.clearedToGo ? "True" : "False",
                sentenced: td?.sentenced ? "True" : "False",
                sentenceConsecutive: td?.sentenceConsecutive ? "True" : "False",
                sealed: td?.sealed ? "True" : "False",
                controllingCharge1: td?.controllingCharge ? "True" : "False",
              };
            })}
            onRowClick={selectChargeFn}
            selected={selectChargeData === null}
          />
        )}
      </ChargesListContainer>
      {isModalShown && (
        <EditChargesModal
          show={isModalShown}
          isEdit={editShow && bookingsFieldsEnabled}
          selectChargeData={selectChargeData}
          onHide={onModalHide}
          chargesData={chargesData}
          bookingBails={bookingBails}
          startingPoint={startingPoint}
        />
      )}
    </>
  );
};

export default ChargesList;
